import React from 'react';
import { FlatList } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { isArray as _isArray } from 'lodash';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import Shimmer from '../Shimmer';
import { LightThemeColors, withTheme } from '../Themes';

import styles from './FilterBar.Styles';
import Item from './Item';
import { filterLoadingConfig, shimmerPlaceholderConfig } from './Loading/LoadingConfig';

const renderLoading = () => (
  <Shimmer config={filterLoadingConfig} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />
);

function FilterBar({
  theme,
  filterData = [],
  selectedCategories = [],
  setSelectedCategories,
  isLoading,
  style,
  withSeeAll,
  seeAllKey,
  containerStyle,
  itemTextStyle,
}) {
  if (!_isArray(filterData)) {
    return null;
  }
  const seeAllFilter = { id: null, name: seeAllKey };
  const prependedData = withSeeAll ? [seeAllFilter, ...filterData] : filterData;

  return isLoading ? (
    renderLoading()
  ) : (
    <>
      <FlatList
        horizontal={true}
        data={prependedData}
        keyboardShouldPersistTaps={'handled'}
        contentContainerStyle={[styles.container, containerStyle]}
        style={[styles.flatListStyle, style]}
        testID={FoundationTestKeys.filterBarFlatList}
        showsHorizontalScrollIndicator={false}
        renderItem={({ item, index }) => (
          <Item
            {...item}
            index={index}
            theme={theme}
            withSeeAll={withSeeAll}
            selectedCategories={selectedCategories}
            setSelectedCategories={setSelectedCategories}
            textAccessibilityLabel={FoundationTestKeys.filterBarItemText}
            itemTextStyle={itemTextStyle}
            testID={FoundationTestKeys.filterItem}
          />
        )}
        keyExtractor={(_item, index) => index + ''}
      />
    </>
  );
}
FilterBar.defaultProps = {
  theme: LightThemeColors,
  withSeeAll: true,
  seeAllKey: 'shop_addons_see_all_categories',
};
FilterBar.propTypes = {
  withSeeAll: PropTypes.bool,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  filterData: PropTypes.oneOfType([
    PropTypes.shape({
      isCatehories: PropTypes.bool,
      data: PropTypes.array,
    }),
    PropTypes.array,
  ]),
  selectedCategories: PropTypes.array,
  setSelectedCategories: PropTypes.func,
  isLoading: PropTypes.bool,
  style: ViewPropTypes.style,
  containerStyle: ViewPropTypes.style,
  itemTextStyle: ViewPropTypes.style,
  seeAllKey: PropTypes.string,
};
export default withTheme(FilterBar);
